module.exports = __webpack_public_path__ + "static/img/Serve13@2x.cba7d0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Serve13@2x.png
// module id = lulG
// module chunks = 1